// Vue
import type { App } from 'vue'

// I18n
import { createI18n } from 'vue-i18n'

// Types
import { Locale } from '@/types'

// Types
import { ITranslations } from '@/translations/translations.interface'

// Translations
import frTranslation from '@/translations/fr'
import enTranslations from '@/translations/en'
import nlTranslations from '@/translations/nl'

const messages: { [key: string]: ITranslations } = {
  'fr-FR': frTranslation,
  'en-GB': enTranslations,
  'nl-NL': nlTranslations,
}

const datetimeFormats = {
  'fr-FR': {
    short: {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
    },
    long: {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
    },
  },
  'en-GB': {
    short: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    },
    long: {
      day: 'numeric',
      month: 'short',
    },
  },
  'nl-NL': {
    short: {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
    },
    long: {
      day: 'numeric',
      month: 'short',
    },
  },
}
const numberFormats = {
  'fr-FR': {
    currency: {
      style: 'currency',
      currency: 'EUR',
      currencyDisplay: 'symbol',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    },
  },
  'en-GB': {
    currency: {
      style: 'currency',
      currency: 'GBP',
      currencyDisplay: 'symbol',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    },
  },
  'nl-NL': {
    currency: {
      style: 'currency',
      currency: 'EUR',
      currencyDisplay: 'symbol',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    },
  },
}

const initI18n = (app: App<Element>, locale: Locale) => {
  const i18n = createI18n({
    legacy: false,
    locale: locale === 'fr-FR-CSE' ? 'fr-FR' : locale,
    fallbackLocale: 'fr-FR',
    messages: messages as any,
    datetimeFormats: datetimeFormats as any,
    numberFormats: numberFormats as any,
    silentTranslationWarn: true, // Suppress warning messages,
    silentFallbackWarn: true,
  })

  app.use(i18n)
}

export default initI18n
